import { Tag } from "components/DesignSystem/Tag/Tag";
import { MessageInput } from "components/MessageInput/MessageInput";
import { useEffect } from "react";
import AIGenerateButtonStar from "static/images/AIGenerateButtonStar.svg";
import { useMessageInputContext } from "stream-chat-react";

const SUGGESTIONS = ["Create a bill", "Create an invoice"];

export const InkleAISuggestions = ({
  label = "Get Started:",
}: {
  label?: string;
}) => {
  const { setText } = useMessageInputContext();

  return (
    <div className="t-flex t-flex-wrap t-gap-2 t-items-center">
      <div id="inkle-ai-get-started" className="t-text-body-sm t-text-text-30">
        {label}
      </div>

      {SUGGESTIONS.map((suggestion, idx) => (
        <div
          key={idx}
          onClick={() => setText(suggestion)}
          className="t-cursor-pointer"
        >
          <Tag rounded icon={false} tagType="white" bordered>
            <div className="t-flex t-items-center t-p-1">
              <img
                src={AIGenerateButtonStar}
                alt="AIGenerateButtonStar"
                className="t-size-4 t-mr-2"
              />
              {suggestion}
            </div>
          </Tag>
        </div>
      ))}
    </div>
  );
};

export const InkleAIMessageInput = ({
  onExploreAllClick,
  prefilledMessage,
  entityId,
}: {
  onExploreAllClick?: () => void;
  prefilledMessage?: string;
  entityId?: string;
}) => {
  const { setText } = useMessageInputContext();

  useEffect(() => {
    if (prefilledMessage) {
      setText(prefilledMessage);
    }
  }, [prefilledMessage, setText]);

  return (
    <div className="t-flex t-flex-col t-gap-4 t-h-full t-w-full">
      <div className="t-flex-1" />
      <div className="t-rounded-tl-2xl t-overflow-hidden">
        <MessageInput hideSLABanner showAISuggestions entityId={entityId} />
      </div>
    </div>
  );
};
